import { render } from "./App.vue?vue&type=template&id=29eb9886"
const script = {}

import "./App.vue?vue&type=style&index=0&id=29eb9886&lang=css"
script.render = render

export default script